export default __webpack_public_path__ + "static/media/Messages.4983b718.svg";